module.exports = __webpack_public_path__ + "media/images/3_4-e02d7bf0b8aeb3ee2a9bb068dfc2a891.png";